"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.umiRequest = exports.errorHandler = void 0;
var umi_request_1 = require("umi-request");
// @ts-ignore
var umi_1 = require("umi");
var qs_1 = require("qs");
var config_1 = require("./config");
var bv_utils_1 = require("bv-utils");
var exception_1 = __importDefault(require("./exception"));
var errorHandler = function (error) {
    var _a, _b, _c;
    var data = error.data, response = error.response;
    if (response) {
        var status_1 = response.status, statusText = response.statusText;
        var title = (_b = (_a = config_1.HTTPStatusTitle[status_1]) !== null && _a !== void 0 ? _a : statusText) !== null && _b !== void 0 ? _b : config_1.defaultError;
        var errorData = data && typeof data === "object" ? bv_utils_1.camelCase(data) : title;
        if (status_1 === 401) {
            // 重新登录后跳转到当前 URL
            if (window.location.pathname !== '/user/login') {
                umi_1.history.replace({
                    pathname: '/user/login',
                    search: qs_1.stringify({ redirect: window.location.href }),
                });
            }
            throw new exception_1.default(errorData, title);
        }
        else if (status_1 === 400 || status_1 === 404) {
            throw new exception_1.default(errorData, (_c = data === null || data === void 0 ? void 0 : data.info) !== null && _c !== void 0 ? _c : title);
        }
        else if (response.status >= 500) {
            throw new exception_1.default(errorData, title);
        }
        else {
            throw new exception_1.default(errorData, title);
        }
    }
    else {
        throw new exception_1.default(null, config_1.defaultError);
    }
};
exports.errorHandler = errorHandler;
// extend 新建一个 umi-request 实例
exports.umiRequest = umi_request_1.extend({
    errorHandler: exports.errorHandler,
    credentials: 'include',
    timeout: 1000 * 60 * 5,
    paramsSerializer: function (p) { return qs_1.stringify(p, { arrayFormat: 'comma' }); },
});
// const toFormData = (data: any) => {
//   const formData = new FormData();
//   Object.keys(data).forEach((item) => {
//     const key = localUnderScoreCase(item)
//     const value = data[key]
//     if ( Array.isArray(value) ) {
//       value.map((i: any) => formData.append(key, i))
//     } else {
//       formData.append(key, value)
//     }
//   });
//   return formData
// }
// request拦截器, 改变url 或 options.
exports.umiRequest.interceptors.request.use(function (url, _a) {
    var data = _a.data, params = _a.params, _b = _a.isLower, isLower = _b === void 0 ? true : _b, r = __rest(_a, ["data", "params", "isLower"]);
    return ({
        url: url,
        options: __assign(__assign({}, r), { data: isLower ? bv_utils_1.lowerCase(data) : data, params: isLower ? bv_utils_1.lowerCase(params) : params }),
    });
});
var request = function (url, options) { return __awaiter(void 0, void 0, void 0, function () {
    var notice, _a, isCamel, r, response, success, data, info, errorMsg, errorRes, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                notice = options.notice, _a = options.isCamel, isCamel = _a === void 0 ? true : _a, r = __rest(options, ["notice", "isCamel"]);
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, exports.umiRequest(url, r)];
            case 2:
                response = _b.sent();
                if (response && typeof response === 'object') {
                    success = response.success, data = response.data, info = response.info;
                    if (success) {
                        return [2 /*return*/, [isCamel ? bv_utils_1.camelCase(data) : data, null]];
                    }
                    errorMsg = info !== null && info !== void 0 ? info : config_1.defaultError;
                    errorRes = data ? (isCamel ? bv_utils_1.camelCase(data) : data) : errorMsg;
                    if (notice) {
                        bv_utils_1.onErrorNotice(notice, errorMsg, undefined, config_1.defaultError);
                    }
                    return [2 /*return*/, [null, errorRes]];
                }
                return [2 /*return*/, [response, null]];
            case 3:
                error_1 = _b.sent();
                if (notice) {
                    bv_utils_1.onErrorNotice(notice || url.split('/api/')[1], error_1, undefined, config_1.defaultError);
                }
                return [2 /*return*/, [null, bv_utils_1.getErrorMsg(error_1, config_1.defaultError)]];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.default = request;
